import { render, staticRenderFns } from "./ShopUserReport.vue?vue&type=template&id=131e0b4c&scoped=true"
import script from "./ShopUserReport.vue?vue&type=script&lang=js"
export * from "./ShopUserReport.vue?vue&type=script&lang=js"
import style0 from "./ShopUserReport.vue?vue&type=style&index=0&id=131e0b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e0b4c",
  null
  
)

export default component.exports